import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from "@/shared/components/ErrorBoundary";
import LoanEligibilityConfigListView from "./views/LoanEligibilityConfigListView";
import LoanEligibilityConfigFormView from "./views/LoanEligibilityConfigFormView";

export const loanEligibilityConfigRoutes: RouteObject[] = [
    {
        path: '/admin/loan-settings/eligibility',
        element: <LoanEligibilityConfigListView />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: '/admin/loan-settings/eligibility/:id',
        element: <LoanEligibilityConfigFormView />,
        errorElement: <ErrorBoundary />,
    }
];
